import React, { useEffect, useState, useContext, useCallback } from "react";
import EnhancedTable from "../elementos/basicos/TablaPersonaLista";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchEliminarPersona, fetchSuspensionPersonas, fetchNegociosData, fetchRolesData, fetchEstadosData, fetchDepartamentosData, fetchPersonasFiltersData, fetchPersonasFiltersAdminData } from '../../peticiones_API/PeticionesGestionPersonasPersonas';
import { fetchPersonasColaboradorasFiltersData, fetchPersonasColaboradorasFiltersAdminData, fetchEliminarPersonaColaboradora, fetchSuspensionPersonasColaboradoras } from '../../peticiones_API/PeticionesPersonasColaboradoras';
import { fetchEmpresasColaboradorasData } from '../../peticiones_API/PeticionesEmpresasColaboradoras';
import { fetchEmpresasData } from '../../peticiones_API/PeticionesGestionPersonasEmpresas';
import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';
import { toast } from "react-toastify";   // solo la funcion: el ToastContainer es global (regla 8)
import GruposDelBuscador from "./correos/GruposDelBuscador";
import { buscarGrupos, mensajeDeError } from "./correos/api";
import Titulo from "../elementos/basicos/Titulo";
import { AvisoContrasenasVisibles } from "./incorporaciones/AvisoContrasenasVisibles";
// La puerta y el contador viven en el candado de la barra. Aquí sólo se lee la ventana.
import { useVentanaSegundoFactor } from "./ui-v2.5";
import { UsuarioContext } from "../providers/personaContext";
import { estadoEfectivo } from "../elementos/eventos/filtros/estadoEfectivo";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PeopleIcon from '@mui/icons-material/People';

// Los mismos tres que ven el campo en la ficha, el grupo `laboral` de la exportación y, desde
// ahora, la ruta `GET /api/empresas`. Una lista, en un sitio, y el servidor la respalda.
const ROLES_CON_EMPRESA_CONTRATANTE = ['administrador', 'super administrador', 'recursos humanos'];

const GestionPersonasPersonas = () => {
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();

    let busqueda = params.get("busqueda") || null;
    let rol = params.get("rol");
    let estado = params.get("estado");
    let departamento = params.get("departamento");
    let negocio = params.get("negocio");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");
    let mostrarDependientes = params.get("mostrar_dependientes") === 'true';
    // Fase A1 · el filtro de verificación, en la URL como los demás. Sólo 'con' o 'sin': cualquier
    // otro valor se descarta en vez de viajar al servidor.
    let verificacion = ['con', 'sin'].includes(params.get("verificacion")) ? params.get("verificacion") : null;
    // 'sin' —las que faltan— o el id de una empresa —quién está en esa razón social—. Nada más:
    // una cadena rara en la URL se ignora aquí, y el servidor la ignoraría igual. La validación
    // está en los dos lados a propósito.
    const ecURL = params.get("empresacontratante");
    let empresaContratante = (ecURL === 'sin' || /^[0-9]+$/.test(ecURL || '')) ? ecURL : null;
    let tabParam = parseInt(params.get("tabPersonas")) || 0;

    const { persona } = useContext(UsuarioContext);

    const [tabActual, setTabActual] = useState(tabParam);
    const [loading, setLoading] = useState(false);

    const [empresasColaboradoras, setEmpresasColaboradoras] = useState([]);


    const puedeVerColaboradores = true;

    /* ── BUZONES Y LISTAS EN EL BUSCADOR (30/10) ──────────────────────────────────────────────
     * Con texto en el buscador y en la pestaña de empleados, se piden aparte los buzones y listas
     * que coinciden (`/api/correos/buscar`) y van ENCIMA de la tabla. Aparte, y no dentro de la
     * respuesta paginada, para no cambiar su forma. Los miembros llegan filtrados por el servidor
     * con las mismas reglas que el listado. Un fallo se dice, no se traga: sin aviso, «no hay
     * buzones» y «no se pudo preguntar» se verían igual. */
    const [grupos, setGrupos] = useState([]);
    const buscaEnInternas = !puedeVerColaboradores || tabActual === 0;
    const textoBuscado = (busqueda || '').trim();
    useEffect(() => {
        let vigente = true;
        if (!textoBuscado || !buscaEnInternas) { setGrupos([]); return undefined; }
        buscarGrupos(textoBuscado)
            .then((r) => { if (vigente) setGrupos((r && r.grupos) || []); })
            .catch((e) => {
                if (!vigente) return;
                setGrupos([]);
                toast.error(mensajeDeError(e, 'No se pudieron buscar los buzones y listas.'));
            });
        return () => { vigente = false; };
    }, [textoBuscado, buscaEnInternas]);
    const textoVacio = !textoBuscado
        ? 'No hay personas con estos filtros.'
        : grupos.length
            ? `Ninguna persona coincide con «${textoBuscado}».`
            : `Nada coincide con «${textoBuscado}»: ni personas, ni buzones, ni listas.`;
    // `key` por búsqueda: «Ocultar» y «Ver todos» son estado local y vuelven a empezar con cada una.
    const encimaDeLaTabla = <GruposDelBuscador key={textoBuscado} grupos={grupos} busqueda={textoBuscado} />;

    const [roles, setRoles] = useState([]);;
    const [estados, setEstados] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [negocios, setNegocios] = useState([]);
    const [empresasContratantes, setEmpresasContratantes] = useState([]);

    const [selected, setSelected] = useState([]);
    // Fase A1 · la puerta del listado. Las contrasenas NO VIENEN hasta pasarla, y al agotarse la
    // ventana se vacian del estado, no se ocultan: ocultar las dejaria en memoria.
    const [secretosVisibles, setSecretosVisibles] = useState(false);
    const ventanaListado = useVentanaSegundoFactor();
    const [recargar, setRecargar] = useState(false);
    const [eliminarSeleccion, setEliminarSeleccion] = useState({ atributo: 'visible', valor: null });

    const [data, setData] = useState({
            meta: {},
            rows: []
        });

    const construirParametrosURL = (pagina) => {
        let urlParams = `?pagina=${pagina}&registrosPorPag=${registrosPorPag}`;
        if (busqueda !== null && busqueda !== '' && busqueda !== undefined) {
            urlParams += `&busqueda=${busqueda}`;
        }
        if (negocio !== null) {
            urlParams += `&negocio=${negocio}`;
        }
        if (departamento !== null) {
            urlParams += `&departamento=${departamento}`;
        }
        if (estado !== null) {
            urlParams += `&estado=${estado}`;
        }
        if (rol !== null) {
            urlParams += `&rol=${rol}`;
        }
        if (verificacion !== null) {
            urlParams += `&verificacion=${verificacion}`;
        }
        if (empresaContratante !== null) {
            urlParams += `&empresacontratante=${empresaContratante}`;
        }
        if (ordenarColumna !== null) {
            urlParams += `&ordenarColumna=${ordenarColumna}`;
        }
        if (orden !== null) {
            urlParams += `&orden=${orden}`;
        }
        if (mostrarDependientes) {
            urlParams += `&mostrar_dependientes=true`;
        }
        if (tabActual !== 0) {
            urlParams += `&tabPersonas=${tabActual}`;
        }
        return urlParams;
    };

        /* ── LOS CATÁLOGOS, UNA VEZ; LA LISTA, CON CADA FILTRO (18/10) ────────────────────────
         *
         * Antes iban en el MISMO efecto que la lista: cada búsqueda, cada página y cada filtro
         * volvían a pedir departamentos, roles, negocios y estados, uno detrás de otro, y sólo
         * después la lista. Medido en producción el 18/10 (medianas de 5): 0,24 + 0,21 + 0,33 +
         * 0,17 s = ~0,95 s de espera y ~93 KB antes de pedir la lista, que tarda 0,25 s. Con la red
         * del equipo de Josune (2,5-4 s por petición), 10-16 s sólo de catálogos.
         *
         * Y esos catálogos casi no cambian: roles y estados sólo con una migración (no hay ruta que
         * escriba en ellos); departamentos y negocios, desde sus pantallas de gestión, que no son
         * ésta. Así que se piden UNA vez, en paralelo, y la lista espera a tenerlos: el filtro de
         * estado nace en «Alta», y el id de «Alta» sale de `estados`. */
        const [catalogosListos, setCatalogosListos] = useState(false);
        const rolDeQuienMira = persona && persona.rol ? persona.rol.toLowerCase() : null;
        useEffect(() => {
            if (!rolDeQuienMira) return undefined;
            let vivo = true;
            (async () => {
                try {
                    const [departamentosResponse, rolesResponse, negociosResponse, estadosResponse] = await Promise.all([
                        fetchDepartamentosData(), fetchRolesData(), fetchNegociosData(), fetchEstadosData(),
                    ]);
                    if (!vivo) return;
                    setDepartamentos(departamentosResponse);
                    setRoles(rolesResponse);
                    setNegocios(negociosResponse);
                    setEstados(estadosResponse);
                    setCatalogosListos(true);
                } catch (error) {
                    // Sin `estados` no se sabe cuál es «Alta», y la lista saldría con todas las
                    // situaciones mezcladas. Mejor decirlo que enseñar una lista que no es la que
                    // dice el filtro.
                    console.log("Ha habido un error con los catálogos:", error);
                    if (vivo) toast.error("No se pudieron cargar los filtros del listado. Recarga la página.");
                }
            })();
            // Las razones sociales, para el desplegable del filtro. SÓLO para los tres roles que lo
            // ven: pedirla a los demás sería una llamada que no lleva a ninguna parte, y el servidor
            // tampoco se la daría — `GET /api/empresas` lleva esos mismos tres roles.
            // Sin esperar: si tarda o falla, el listado sale igual y el desplegable se queda con
            // «Sin asignar». Un filtro es una herramienta, no un requisito para ver la tabla.
            if (ROLES_CON_EMPRESA_CONTRATANTE.includes(rolDeQuienMira)) {
                fetchEmpresasData()
                    .then((d) => { if (vivo) setEmpresasContratantes((d || []).slice().sort((a, b) =>
                        (a.razon_social || '').localeCompare(b.razon_social || ''))); })
                    .catch(() => { if (vivo) setEmpresasContratantes([]); });
            }
            return () => { vivo = false; };
        }, [rolDeQuienMira]);

        // Las empresas colaboradoras, la primera vez que se abre su pestaña, y no en cada búsqueda.
        const esTabColaboradores = tabActual === 1 && puedeVerColaboradores;
        useEffect(() => {
            if (!esTabColaboradores || empresasColaboradoras.length) return undefined;
            let vivo = true;
            fetchEmpresasColaboradorasData().then((data) => { if (vivo) setEmpresasColaboradoras(data || []); }).catch(() => {});
            return () => { vivo = false; };
        }, [esTabColaboradores, empresasColaboradoras.length]);

        useEffect(() => {
            /* LA RESPUESTA DE UNA BÚSQUEDA VIEJA NO PISA A LA NUEVA (18/10). Cada ejecución de este
             * efecto tiene su `vigente`; al cambiar un filtro, React limpia la anterior y lo que
             * llegue de ella se descarta —ni `setData`, ni `navigate`, ni `setLoading`—. Antes se
             * aplicaba cualquier respuesta en el orden en que llegase, y con una red lenta la de
             * «ana» podía llegar después de la de «anabel». */
            let vigente = true;
            async function fechtPrincipal() {
                if (!persona || !persona.rol || !catalogosListos) return;
                setLoading(true);
                try {
                    /* ── EL FILTRO DE ESTADO NACE EN «ALTA» ──────────────────────────────────
                     *
                     * Antes el listado arrancaba con un SUELO en el servidor (`activo: true`) y
                     * el selector «Activo» era la unica llave para levantarlo. Eso tenia dos
                     * efectos raros: filtrar «Estado = Baja» devolvia CERO, y `recursos humanos`
                     * veia menos que un `general` porque el suelo solo estaba en `/filters`.
                     *
                     * Ahora el servidor no filtra por acceso y la eleccion es de esta pantalla.
                     * El defecto va AQUI y no en el backend a proposito: es el mismo componente
                     * el que llama a `/filters` o a `/adminfilters` segun el rol, asi que
                     * ponerlo aqui lo aplica a todos por igual. En una de las dos funciones del
                     * servidor habria invertido la incoherencia en vez de cerrarla.
                     *
                     * El id se busca POR NOMBRE en `estados`, no se deduce. Y por eso esta lista
                     * espera a `catalogosListos`: sin `estados` no hay id de «Alta».
                     *
                     * `estado === 'todos'` es el caso nuevo —el que hasta hoy no existia—: se
                     * manda `null` y salen todas las situaciones.
                     */
                    // LA MISMA función que el botón de exportar (estadoEfectivo.js): antes esto
                    // era una copia en línea, y el botón decía usar «la misma que el listado».
                    // Lleva también la regla del rol (hotfix 23/10): quien no gestiona personas
                    // filtra siempre por «Alta».
                    const estadoFiltrado = estadoEfectivo(estado, estados, persona.rol);

                    let fetchFuncion;
                    if (esTabColaboradores) {
                        fetchFuncion = ["administrador", "general", "super administrador"].includes(persona.rol.toLowerCase())
                            ? fetchPersonasColaboradorasFiltersAdminData
                            : fetchPersonasColaboradorasFiltersData;
                    } else {
                        fetchFuncion = ["administrador", "general", "super administrador"].includes(persona.rol.toLowerCase())
                            ? fetchPersonasFiltersAdminData
                            : fetchPersonasFiltersData;
                    }

                    /* UNA LLAMADA, NO DOS RAMAS. Antes había una `fetchFuncion` compartida pero
                       DOS listas de argumentos distintas, y la de colaboradores cortaba en el 11º:
                       `ventana` no viajaba y las contraseñas llegaban vacías con la puerta abierta.
                       Ese riesgo estaba ESCRITO en el comentario que había aquí —se arregló el
                       argumento `activo` y se dejó el otro—, y estar escrito hizo que pareciera
                       atendido.
                       Las dos firmas convergen ahora, así que la rama elige la FUNCION y nunca los
                       argumentos. No se puede volver a divergir sin borrar esto. */
                    const pedirPersonas = (pag, porPag) => fetchFuncion(
                        pag, porPag, rol, estadoFiltrado, departamento, negocio, busqueda,
                        ordenarColumna, orden, mostrarDependientes, null, false, verificacion,
                        ventanaListado.ventana, empresaContratante,
                    );

                    if (!paginaActual || !registrosPorPag) {
                        const personasResponse = await pedirPersonas(paginaActual, registrosPorPag);
                        if (!vigente) return;
                        const { data: personasData, meta } = personasResponse;

                        paginaActual = meta.current_page;
                        registrosPorPag = meta.per_page;

                        /* `construirParametrosURL` y NO la plantilla a pelo: aquella escribia
                         * solo `pagina` y `registrosPorPag`, y el resto de la URL se perdia. */
                        navigate(`${urlPadre}${construirParametrosURL(paginaActual)}`);
                        setData({
                            meta,
                            rows: personasData
                        });
                    } else {
                        const urlParams = construirParametrosURL(paginaActual);
                        navigate(`${urlPadre}${urlParams}`);

                        const personasResponse = await pedirPersonas(paginaActual, registrosPorPag);
                        if (!vigente) return;
                        const { data: personasData, meta } = personasResponse;
                        setSecretosVisibles(!!personasResponse.secretosVisibles);

                        if (personasData.length === 0 && paginaActual > 1 && meta.total > 0) {
                            const urlParamsPage1 = construirParametrosURL(1);
                            navigate(`${urlPadre}${urlParamsPage1}`);
                            return;
                        }

                        setData({
                            meta,
                            rows: personasData
                        });
                    }

                    setLoading(false);

                } catch (error) {
                    if (vigente) console.log("Ha habido un error:", error);
                }
            }
            fechtPrincipal();
            return () => { vigente = false; };
        }, [recargar, paginaActual, registrosPorPag, rol, estado, departamento, negocio, busqueda, ordenarColumna, orden, mostrarDependientes, navigate, urlPadre, persona, esTabColaboradores, verificacion, ventanaListado.ventana, empresaContratante, catalogosListos, estados]);

        const confirmDialog = ConfirmacionEliminar();

    const funcionEliminar = useCallback(async () => {
        if(selected.length === 0){
            setEliminarSeleccion((prevState) => ({
                ...prevState,
                valor: null,
            }));
            return;
        };
        const confirm = await confirmDialog.showAlert("eliminar","personas");
        if (confirm) {
            let personasEliminar = [];
            if (eliminarSeleccion.valor === false && selected.length !== 0) {
                personasEliminar = selected;
                const esTabColab = tabActual === 1 && puedeVerColaboradores;
                if (esTabColab) {
                    await fetchEliminarPersonaColaboradora(personasEliminar);
                } else {
                    await fetchEliminarPersona(personasEliminar);
                }
                setSelected([])
            }
            setRecargar(!recargar)
        }
        setEliminarSeleccion((prevState) => ({
            ...prevState,
            valor: null,
        }));
    }, [selected, eliminarSeleccion.valor, confirmDialog, recargar, setSelected]);

    useEffect(() => {
        if (eliminarSeleccion.valor !== null) {
            funcionEliminar();
        }
    }, [eliminarSeleccion.valor, funcionEliminar]);
    /**
     * Suspender o levantar en grupo.
     *
     * **El resultado se cuenta, no se da por hecho.** Sólo se suspende a quien está en Alta y sólo
     * se levanta a quien está suspendido, así que en una selección de veinte habrá gente a la que
     * no se le aplica — alguien en Baja Médica, alguien ya suspendido—. Un aviso de «hecho» a secas
     * escondería precisamente lo que no se hizo, y nadie volvería a mirarlo.
     */
    const funcionCambiarEstadoActivo = async (personasIds, suspenderlas) => {
        try {
            const esTabColab = tabActual === 1 && puedeVerColaboradores;
            const r = esTabColab
                ? await fetchSuspensionPersonasColaboradoras(personasIds, suspenderlas)
                : await fetchSuspensionPersonas(personasIds, suspenderlas);

            const hechas = (r && r.aplicadas) ? r.aplicadas.length : 0;
            const fuera = (r && r.omitidas) ? r.omitidas : [];
            const verbo = suspenderlas ? 'suspendida(s)' : 'reincorporada(s)';
            if (hechas > 0) toast.success(`${hechas} persona(s) ${verbo}.`);
            if (fuera.length > 0) {
                // El motivo, traducido. Decir «solo_desde_alta» sería no decir nada.
                const porQue = {
                    solo_desde_alta: 'no está en Alta',
                    ya_suspendida: 'ya estaba suspendida',
                    no_estaba_suspendida: 'no estaba suspendida',
                    persona_no_encontrada: 'no se ha encontrado',
                };
                const detalle = fuera.map((o) => `#${o.id} (${porQue[o.motivo] || o.motivo})`).join(', ');
                toast.warn(`${fuera.length} sin cambios: ${detalle}`, { autoClose: 8000 });
            }
            if (hechas === 0 && fuera.length === 0) toast.info('No se ha cambiado nada.');

            setSelected([]);
            setRecargar(!recargar);
        } catch (error) {
            console.error("Error al cambiar estado activo de personas:", error);
        }
    };

    const [header, setHeader] = useState([
    {
        id: 'nombre',
        numeric: false,
        disablePadding: true,
        label: 'Nombre',
        align: 'left'
    },
    {
        id: 'apellidos',
        numeric: false,
        disablePadding: false,
        label: 'Apellidos',
        align: 'right'
    },
    {
        id: 'telefono_empresa',
        numeric: true,
        disablePadding: false,
        label: 'Móvil',
        align: "right"
    },
    {
        id: 'extension_telefono',
        numeric: true,
        disablePadding: false,
        label: 'Ext',
        align: "right"
    },
    {
        id: 'telefono_fijo',
        numeric: true,
        disablePadding: false,
        label: 'Fijo',
        align: "right"
    },
    {
        id: 'mail_empresa',
        numeric: false,
        disablePadding: false,
        label: 'Mail Empresa',
        align: 'right'
    },
    {
        id: 'oficinas',
        numeric: false,
        disablePadding: false,
        label: 'Oficinas',
        align: 'right'
    },
    {
        id: 'poblacion',
        numeric: false,
        disablePadding: false,
        label: 'Población',
        align: 'right'
    },
    {
        id: 'rol',
        numeric: false,
        disablePadding: false,
        label: 'Rol',
        align: 'right'
    },
    {
        id: 'conexion_remota',
        numeric: true,
        disablePadding: false,
        label: '',
        align: 'right'
    },
    {
        id: 'modificar',
        numeric: true,
        disablePadding: false,
        label: '',
        align: 'right'
    }
]);

    // Fase A1 · la columna del segundo factor. Sólo para los dos roles altos — y el backend
    // tampoco manda `totp_enabled` a los demás, así que no depende de esconderla aquí.
    // Fase A1 · las dos columnas de contrasena solo existen con la puerta pasada. No se
    // enmascaran: no aparecen. Es mas honesto —no promete un dato que no puedes ver— y la tabla
    // no se llena de puntos.
    const COLUMNAS_SECRETO = [
        { id: 'password_nas', numeric: false, disablePadding: false, label: 'Password NAS', align: 'right' },
        { id: 'password_m365', numeric: false, disablePadding: false, label: 'Password 365', align: 'right' },
    ];

    // Fase A1 · al agotarse la ventana, las contrasenas se van DEL ESTADO, no se ocultan.
    // Ocultarlas las dejaria en memoria y en las herramientas del navegador. Se recarga el
    // listado sin ventana, que es lo que de verdad las retira: vienen del servidor o no vienen.
    useEffect(() => {
        if (!secretosVisibles || ventanaListado.activa) return;
        setSecretosVisibles(false);
        setData(prev => ({
            ...prev,
            rows: (prev.rows || []).map(f => {
                const { password_nas, password_m365, ...resto } = f;
                return resto;
            }),
        }));
        setRecargar(r => !r);
        toast.info('La verificación ha caducado. Las contraseñas se han ocultado.');
    }, [ventanaListado.activa, secretosVisibles]);

    useEffect(() => {
        const rolUsuario = persona?.rol;
        const headerBase = header.filter(item => item.id !== 'rol' && item.id !== 'modificar' && item.id !== 'conexion_remota' && item.id !== 'fecha_alta' && item.id !== 'totp_enabled' && item.id !== 'password_nas' && item.id !== 'password_m365');

        const mostrarFechaAlta = estado === "2";

        if(rolUsuario === "Administrador"){
            const columnaRolOFecha = mostrarFechaAlta
                ? {
                    id: 'fecha_alta',
                    numeric: false,
                    disablePadding: false,
                    label: 'Fecha Alta',
                    align: "right"
                }
                : {
                    id: 'rol',
                    numeric: false,
                    disablePadding: false,
                    label: 'Rol',
                    align: "right"
                };

            setHeader([
                ...headerBase,
                columnaRolOFecha,
                {
                    id: 'modificar',
                    numeric: true,
                    disablePadding: false,
                    label: '',
                    align: "right"
                }
            ]);
        }else if (rolUsuario === "Super Administrador"){
            const columnaRolOFecha = mostrarFechaAlta
                ? {
                    id: 'fecha_alta',
                    numeric: false,
                    disablePadding: false,
                    label: 'Fecha Alta',
                    align: "right"
                }
                : {
                    id: 'rol',
                    numeric: false,
                    disablePadding: false,
                    label: 'Rol',
                    align: "right"
                };

             setHeader([
                {
                    id: 'nombre',
                    numeric: false,
                    disablePadding: true,
                    label: 'Nombre',
                    align: "right"
                },
                {
                    id: 'apellidos',
                    numeric: false,
                    disablePadding: false,
                    label: 'Apellidos',
                    align: "right"
                },
                {
                    id: 'telefono_empresa',
                    numeric: true,
                    disablePadding: false,
                    label: 'Móvil',
                    align: "right"
                },
                {
                    id: 'extension_telefono',
                    numeric: true,
                    disablePadding: false,
                    label: 'Ext',
                    align: "right"
                },
                {
                    id: 'telefono_fijo',
                    numeric: true,
                    disablePadding: false,
                    label: 'Fijo',
                    align: "right"
                },
                {
                    id: 'mail_empresa',
                    numeric: false,
                    disablePadding: false,
                    label: 'Mail Empresa',
                    align: "right"
                },
                {
                    id: 'usuario_nas',
                    numeric: false,
                    disablePadding: false,
                    label: 'Usuario NAS',
                    align: "right"
                },
                // Fase A1 · solo con la puerta pasada. `...[]` las hace desaparecer de la
                // cabecera, no solo de las celdas: la tabla no promete lo que no puede enseñar.
                ...(secretosVisibles ? COLUMNAS_SECRETO : []),
                columnaRolOFecha,
                {
                    id: 'conexion_remota',
                    numeric: true,
                    disablePadding: false,
                    label: '',
                    align: "right"
                },
                {
                    id: 'modificar',
                    numeric: true,
                    disablePadding: false,
                    label: '',
                    align: "right"
                }
            ]);
        }else if (rolUsuario === "Recursos Humanos") {
            if (mostrarFechaAlta) {
                setHeader([
                    ...headerBase,
                    {
                        id: 'fecha_alta',
                        numeric: false,
                        disablePadding: false,
                        label: 'Fecha Alta',
                        align: "right"
                    },
                    {
                        id: 'modificar',
                        numeric: true,
                        disablePadding: false,
                        label: '',
                        align: "right"
                    }
                ]);
            } else {
                setHeader([
                    ...headerBase,
                    {
                        id: 'modificar',
                        numeric: true,
                        disablePadding: false,
                        label: '',
                        align: "right"
                    }
                ]);
            }
        }else{
            // Quien no gestiona personas recibe del servidor sólo la agenda (hotfix 23/10,
            // `filasParaRol` en services/camposListado.js): ni población ni fecha de alta. Pintar
            // esas columnas las dejaría vacías, y una celda vacía dice «no tiene», no «no lo ves».
            setHeader(headerBase.filter(item => item.id !== 'poblacion'));
        }
    }, [persona, estado, secretosVisibles]);



    const handleTabChange = (event, newValue) => {
        setTabActual(newValue);
        const newParams = new URLSearchParams(location.search);

        if (newValue === 0) {
            newParams.delete('tabPersonas');
        } else {
            newParams.set('tabPersonas', newValue.toString());
        }

        newParams.set('pagina', '1');
        navigate(`${urlPadre}?${newParams.toString()}`);
    };



    return (
        <>
            <div className="mb-[1%]">
                <Titulo
                    texto="PERSONAS"
                    tituloTabla="true"
                />
            </div>

            {puedeVerColaboradores && (
                <div className="border-b border-gray-200 mb-4">
                    <Tabs
                        value={tabActual}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': {
                                fontWeight: 'bold',
                                textTransform: 'none',
                                fontSize: '1rem'
                            },
                            '& .Mui-selected': {
                                color: '#336385'
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#336385'
                            }
                        }}
                    >
                        <Tab icon={<PeopleIcon />} iconPosition="start" label="Emplead@s" />
                        {puedeVerColaboradores && (
                            <Tab icon={<PeopleIcon />} iconPosition="start" label="Colaboradores" />
                        )}
                    </Tabs>
                </div>
            )}

            {tabActual === 0 && <AvisoContrasenasVisibles visible={secretosVisibles} />}

            {(tabActual === 0 && puedeVerColaboradores) && (
                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    roles={roles}
                    estados={estados}
                    departamentos={departamentos.filter(dep => dep.tipo === "interno")}
                    empresas={negocios}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarSeleccion={eliminarSeleccion}
                    setEliminarSeleccion={setEliminarSeleccion}
                    isLoading={loading}
                    busqueda={busqueda}
                    empresasContratantes={empresasContratantes}
                    onCambiarEstadoActivo={funcionCambiarEstadoActivo}
                    esColaboradores={false}
                    encimaDeLaTabla={encimaDeLaTabla}
                    textoVacio={textoVacio}
                    totalGrupos={grupos.length}
                />
            )}

            {!puedeVerColaboradores && (
                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    roles={roles}
                    estados={estados}
                    departamentos={departamentos.filter(dep => dep.tipo === "interno")}
                    empresas={negocios}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarSeleccion={eliminarSeleccion}
                    setEliminarSeleccion={setEliminarSeleccion}
                    isLoading={loading}
                    busqueda={busqueda}
                    empresasContratantes={empresasContratantes}
                    onCambiarEstadoActivo={funcionCambiarEstadoActivo}
                    esColaboradores={false}
                    encimaDeLaTabla={encimaDeLaTabla}
                    textoVacio={textoVacio}
                    totalGrupos={grupos.length}
                />
            )}

            {tabActual === 1 && puedeVerColaboradores && (
                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    roles={roles}
                    estados={estados}
                    departamentos={departamentos.filter(dep => dep.tipo === "interno")}
                    empresas={empresasColaboradoras}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarSeleccion={eliminarSeleccion}
                    setEliminarSeleccion={setEliminarSeleccion}
                    isLoading={loading}
                    busqueda={busqueda}
                    onCambiarEstadoActivo={funcionCambiarEstadoActivo}
                    esColaboradores={true}
                />
            )}



        </>
     );
}


export default GestionPersonasPersonas;
